import {useState} from "react";
import handleOnBlur from "@Features/input/functions/handleOnBlur";
import nextInput from "@Features/input/functions/nextInput";

interface UseInputAttributes {
    validate?: (any) => any,
    scrollToNextInputFunction?: () => any,
}

export default function useInput(props: UseInputAttributes) {
    const {
        validate = () => false,
        scrollToNextInputFunction,
    } = props

    const [inputData, setInputData] = useState("")
    const [inputClassName, setInputClassName] = useState("")

    const handleDataInput = async ({target: {value}}) => {
        setInputData(value)
    }

    const goToNextInputField = async (event) => {
        nextInput(event, scrollToNextInputFunction)
    }

    const handleFocusOutOfInputField = async ({target: {value}}) => {
        await handleOnBlur({
            value,
            validate,
            defaultClassName: "border-warning",
            onBlurClassName: "border-validated",
            setClassName: setInputClassName,
        })
    }

    return {
        inputData,
        setInputData,
        handleDataInput,
        inputClassName,
        handleFocusOutOfInputField,
        goToNextInputField,
    }
}